/**
 * Datatable definition for the Agencies table.
 */

var app_agencies_table = $('#app-agencies-table');

if (app_agencies_table.length) {
    var data_table_order=[ 0, "asc" ];
    function initializeVedorsTable() {
        window.app_agencies_table
            .DataTable({
                ajax: {
                    url: '/agency/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},
                    {data: 'id'},
                    {data: 'name'},
                    {data: 'slug'}
                ],
                order: data_table_order,
                pageLength: user_entries,
                destroy: true,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '<input id="'+ cellData +'" name="sel_agencies[]" type="checkbox" value="'+cellData+'" style="-webkit-transform: scale(2);transform: scale(2);padding: 10px;">';
                            $(td).html(html);
                        }
                    },
                    {
                    "targets": 3,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var statusVar = "";
                        if (rowData.active == 1)
                            statusVar = 'Deactivate';
                        else
                            statusVar = 'Activate';
                        disabledClass = '';
                        if (rowData.id == 1)
                            disabledClass = ' disabled';
                        var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                            '<a href="/agency/' +
                            cellData +
                            '/ghost/" role="button" class="btn btn-default btn-sm">' +
                            '<i class="fa fa-user"></i> Ghost' +
                            '</a>' +
                            '<a href="/agency/' +
                            cellData +
                            '" role="button" class="btn btn-success btn-sm' + disabledClass + '">' +
                            '<i class="fa fa-pencil"></i> Edit' +
                            '</a>';
                        if (rowData.id == 1)
                            html = html + '<a href="javascript:void(0)" role="button"';
                        else
                            html = html + '<a href="javascript:void(0)" onclick="changeAgencyStatus(\'/agency/' +
                                cellData + '/active' + '\',\'' + statusVar + '\')" role="button"';

                        if (rowData.active == 1) {
                            html = html +
                                ' class="btn btn-warning btn-sm' + disabledClass + '"><i class="fa fa-eye-slash"></i> Deactivate';
                        } else {
                            html = html +
                                ' class="btn btn-info btn-sm' + disabledClass + '"><i class="fa fa-eye"></i> Activate';
                        }
                        if (rowData.id == 1)
                            html = html +
                                '</a>' +
                                '<a href="javascript:void(0)" role="button" class="btn btn-danger btn-sm disabled">' +
                                '<i class="fa fa-trash-o"></i> Delete' +
                                '</a></div>';
                        else
                            html = html +
                                '</a>' +
                                '<a href="javascript:void(0)" onclick="deleteAgency(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                '<i class="fa fa-trash-o"></i> Delete' +
                                '</a></div>';
                        $(td).html(html);
                    }
                }]
            });
    }
    $('#app-advertisers-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-advertisers-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );

    var progress_loader_steps = 0;
    var progress_loader_curr_step = 0;
    var update_progress_loader = function (message, steps) {
        var container = $('#progressloader_ws');

        progress_loader_curr_step++;
        width = (progress_loader_curr_step / progress_loader_steps) * 100;
        container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
        if (steps === true) {
            message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
        }
        container.find('span').html(message + '...');
        if(progress_loader_steps <= progress_loader_curr_step)
            close_progress_loader();
    };

    var init_progress_loader = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;

        update_progress_loader(message);

        $('#progressloader_ws').show();
    };

    var close_progress_loader = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloader_ws').hide();
    };

    $('#source_update_agencies_selected').on('click', function(){
        swal({
                title: "Warning",
                text: "Are you sure you want to import stations for selected agencies?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    var ids = [];
                    $('#app-agencies-table input[type="checkbox"]').each(function() {
                        if ($(this).is(":checked")) {
                            ids.push($(this).val());
                        }
                    });
                    if(ids.length === 0)
                        alert('Please select at least one agency.');
                    else{
                        init_progress_loader(1, "Pulling Stations from Nielsen, Eastlan and Comscore. Please be patient; this operation could take a while.");
                        var  params = {
                            agency_ids: ids,
                        }
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: '/agency/updateallselected',
                            dataType: "json",
                            contentType: "application/json",
                            success: function (data) {
                                console.log('data: ', data);
                                close_progress_loader();
                                swal({
                                        title: "Success",
                                        text: "Stations Imported!!",
                                        type: "success",
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "Ok",
                                        closeOnConfirm: true,
                                    },
                                    function (isConfirm) {

                                    });
                            },
                            error: function (xhr) {
                                ajax_error();
                                debug(xhr.responseText);
                                close_progress_loader();
                                swal({
                                        title: "Ups!",
                                        text: "An error happened. Please check your networkks or contact Sergio.",
                                        type: "error",
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "Ok",
                                        closeOnConfirm: true,
                                    },
                                    function (isConfirm) {

                                    });
                            }
                        });
                    }
                }
            });
    })

    $('#source_update_agencies').on('click', function(){
        swal({
                title: "Warning",
                text: "Are you sure you want to import stations for selected agencies?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    var ids = [];
                    init_progress_loader(1, "Pulling Stations from Nielsen, Eastlan and Comscore. Please be patient; this operation could take a while.");
                    var  params = {
                        agency_ids: ids,
                    }
                    $.ajax({
                        type: 'POST',
                        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                        data: JSON.stringify(params),
                        url: '/agency/updateall',
                        dataType: "json",
                        contentType: "application/json",
                        success: function (data) {
                            console.log('data: ', data);
                            close_progress_loader();
                            swal({
                                    title: "Success",
                                    text: "Stations Imported!!",
                                    type: "success",
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Ok",
                                    closeOnConfirm: true,
                                },
                                function (isConfirm) {

                                });
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            close_progress_loader();
                            swal({
                                    title: "Ups!",
                                    text: "An error happened. Please check your networkks or contact Sergio.",
                                    type: "error",
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Ok",
                                    closeOnConfirm: true,
                                },
                                function (isConfirm) {

                                });
                        }
                    });
                }
            });
    })

    $('#sel_all_agencies').on('click', function (){
        if($(this).html() === 'Select All'){
            $('#app-agencies-table input[type="checkbox"]').each(function() {
                $(this).prop("checked", "checked")
            });
            $(this).html('Deselect All')
        }else{
            $('#app-agencies-table input[type="checkbox"]').each(function() {
                $(this).prop("checked", "")
            });
            $(this).html('Select All')
        }
    })

    $('#ordered_by_agency').on('click', function(){
        console.log('get report');
        init_progress_loader(1, "Calculating TV totals. Please be patient; this operation could take a while.");
        $.ajax({
            url: '/ordered-by-agency',
            success: function (response) {
                console.log(response);
                var html = '';
                for (var agency_id in response.agencies){
                    html += '<tr>';
                    html += '<td>'+ agency_id +'</td>';
                    for (var month in response.agencies[agency_id])
                        html += '<td>$'+ Math.round(parseFloat(response.agencies[agency_id][month])) +'</td>';
                    html += '</tr>';
                }
                html += '<tr>';
                html += '<td>Total</td>';
                for (var month in response.totals)
                    html += '<td>$'+ Math.round(parseFloat(response.totals[month])) +'</td>';
                html += '</tr>';
                $('#totals_content').html(html);
                $('.totals_modal').modal('show');
                close_progress_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    console.log('xhr: ', xhr);
                    ajax_error();
                    debug(xhr.responseText);
                }
                close_progress_loader();
            }
        });
    });

    function exportTableToExcel(tableID, filename = ''){
        var downloadLink;
        var dataType = 'application/vnd.ms-excel';
        var tableSelect = document.getElementById(tableID);
        var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

        // Specify file name
        filename = filename?filename+'.xls':'excel_data.xls';

        // Create download link element
        downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if(navigator.msSaveOrOpenBlob){
            var blob = new Blob(['\ufeff', tableHTML], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob( blob, filename);
        }else{
            // Create a link to the file
            downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }
    }

    $('#ordered_by_agency_radio').on('click', function(){
        console.log('get report');
        init_progress_loader(1, "Calculating Radio totals. Please be patient; this operation could take a while.");
        $.ajax({
            url: '/ordered-by-agency-radio',
            success: function (response) {
                console.log(response);
                var html = '';
                for (var agency_id in response.agencies){
                    html += '<tr>';
                    html += '<td>'+ agency_id +'</td>';
                    for (var month in response.agencies[agency_id])
                        html += '<td>$'+ Math.round(parseFloat(response.agencies[agency_id][month])) +'</td>';
                    html += '</tr>';
                }
                html += '<tr>';
                html += '<td>Total</td>';
                for (var month in response.totals)
                    html += '<td>$'+ Math.round(parseFloat(response.totals[month])) +'</td>';
                html += '</tr>';
                $('#totals_content').html(html);
                $('.totals_modal').modal('show');
                close_progress_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                close_progress_loader();
            }
        });
    });

    $('#ordered_by_agency_new').on('click', function(){
        console.log('get report');
        init_progress_loader(1, "Calculating Totals. Please be patient; this operation could take a while.");
        $.ajax({
            url: '/ordered-by-agency-new/3',
            success: function (response) {
                console.log(response);
                var html = ''; var i =0;
                for (var month in response.data){
                    if(i === 0) {
                        html += '<tr>';
                        html += '<td><b>Month</b></td>';
                        for (var mtype in response.data[month])
                            html += '<td><b>' + mtype.toUpperCase() + '</b></td>';
                        html += '<td><b>Total</b></td>';
                        html += '</tr>';
                        i++;
                    }
                    var total = 0;
                    html += '<tr>';
                    html += '<td><b>' + month + '</b></td>';
                    for (var mtype in response.data[month]) {
                        html += '<td>$' + response.data[month][mtype].toFixed(2) + '</td>';
                        total += parseFloat(response.data[month][mtype].toFixed(2));
                    }
                    html += '<td>'+ total +'</td>';
                    html += '</tr>';
                }

                $('#totals_content_3').html(html);
                $('.totals_modal_3').modal('show');
                close_progress_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                close_progress_loader();
            }
        });
    });

    $('#ordered_by_agency_iheart').on('click', function(){
        console.log('get report');
        init_progress_loader(1, "Calculating Totals. Please be patient; this operation could take a while.");
        $.ajax({
            url: '/ordered-by-agency-iheart/24',
            success: function (response) {
                console.log(response);
                var html = ''; var i =0;
                for (var month in response.data){
                    if(i === 0) {
                        html += '<tr>';
                        html += '<td><b>Month</b></td>';
                        for (var mtype in response.data[month])
                            html += '<td><b>' + mtype.toUpperCase() + '</b></td>';
                        html += '<td><b>Total</b></td>';
                        html += '</tr>';
                        i++;
                    }
                    var total = 0;
                    html += '<tr>';
                    html += '<td><b>' + month + '</b></td>';
                    for (var mtype in response.data[month]) {
                        html += '<td>$' + response.data[month][mtype].toFixed(2) + '</td>';
                        total += parseFloat(response.data[month][mtype].toFixed(2));
                    }
                    html += '<td>'+ total +'</td>';
                    html += '</tr>';
                }

                $('#totals_content_3').html(html);
                $('.totals_modal_3').modal('show');
                close_progress_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                close_progress_loader();
            }
        });
    });

    $('#ordered_by_agency_cable_vendor').on('click', function(){
        console.log('get report');
        init_progress_loader(1, "Calculating Cable totals. Please be patient; this operation could take a while.");
        $.ajax({
            url: '/ordered-by-agency-cable-vendor',
            success: function (response) {
                console.log(response);
                var html = '';
                for (var agency_id in response.agencies) {
                    for (var vendor_id in response.agencies[agency_id]) {
                        html += '<tr>';
                        html += '<td style="text-align: center">' + agency_id + '</td>';
                        html += '<td style="text-align: center">' + vendor_id + '</td>';
                        for (var month in response.agencies[agency_id][vendor_id])
                            html += '<td style="text-align: center">$' + Math.round(parseFloat(response.agencies[agency_id][vendor_id][month])) + '</td>';
                        html += '</tr>';
                    }
                }
                html += '<tr>';
                html += '<td style="text-align: center">Total</td>';
                html += '<td style="text-align: center">-</td>';
                for (var month in response.totals)
                    html += '<td style="text-align: center">$'+ Math.round(parseFloat(response.totals[month])) +'</td>';
                html += '</tr>';
                $('#totals_content_cable_vendor').html(html);
                $('.totals_modal_cable_vendor').modal('show');
                close_progress_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    console.log('xhr: ', xhr);
                    ajax_error();
                    debug(xhr.responseText);
                }
                close_progress_loader();
            }
        });
    });


    function deleteAgency(url) {
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: '/agency/' + url + '/destroy',
                        success: function (response) {
                            global_notification('success', 'Agency deleted.');
                            initializeVedorsTable();
                            close_progress_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });

    }

    function changeAgencyStatus(urlVar, statusVar) {
        swal({
                title: "Warning",
                text: "Are you sure you want to " + statusVar + " agency?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Agency ' + statusVar + 'd');
                            initializeVedorsTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });
    }

    initializeVedorsTable();

    $('#agencies-rf-report').on('click', function (){
        show_loader();
        $.ajax({
            type: 'GET',
            dataType: 'json',
            encode: true,
            url: '/get/agencies/rf/report',
            success: function (data) {
                $('#select_agency_reach_freq').select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 3
                }).html(data);
                $('#ReachFreqReportModal').modal('show');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
                //hide_overlay_loader("#addAvailsToOrder");
            }

        });
    });

    $('#agencies-rf-report-submit').on('click', function (){
        init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
        var url = '/agencies-rf-report/' + $('#select_agency_reach_freq option:selected').val();
        $.ajax({
            type: 'GET',
            dataType: 'json',
            encode: true,
            url: url,
            success: function (data) {
                var html =  data;
                var dt = new Date();
                var day = dt.getDate();
                var month = dt.getMonth() + 1;
                var year = dt.getFullYear();
                var hour = dt.getHours();
                var mins = dt.getMinutes();
                var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
                //creating a temporary HTML link element (they support setting file names)
                var a = document.createElement('a');
                //getting data from our div that contains the HTML table
                var data_type = 'data:application/vnd.ms-excel';
                var aux = html.replace("PRINT", "");
                aux = aux.replace("DOWNLOAD", "");
                aux = aux.replace("NO STYLE", "");
                aux = aux.replaceAll(".0<", ".0&nbsp;<");
                console.log('table: ', aux);
                a.href = data_type + ', ' + encodeURIComponent(aux);
                //setting the file name
                a.download = 'ReachAndFreq_' + postfix + ' '+ $('#select_agency_reach_freq option:selected').html() +'.xls';
                //triggering the function
                a.click();
                // just in case, prevent default behaviour
                if(typeof e !== 'undefined')
                    e.preventDefault();

                return false;
                $('#ReachFreqReportModal').modal('hide');
                close_progress_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
                //hide_overlay_loader("#addAvailsToOrder");
            }

        });

    });

    $('#accounting-report').on('click', function (){
        init_progress_loader(2, 'This operation could take few seconds. Please wait ...');

        $.ajax({
            type: 'GET',
            dataType: 'json',
            encode: true,
            url: '/get/accounting_package/report',
            success: function (data) {
                var html =  data;
                var dt = new Date();
                var day = dt.getDate();
                var month = dt.getMonth() + 1;
                var year = dt.getFullYear();
                var hour = dt.getHours();
                var mins = dt.getMinutes();
                var postfix = month + "." + day + "." + year + "_" + hour + "." + mins;
                //creating a temporary HTML link element (they support setting file names)
                var a = document.createElement('a');
                //getting data from our div that contains the HTML table
                var data_type = 'data:application/vnd.ms-excel';
                var aux = html.replace("PRINT", "");
                aux = aux.replace("DOWNLOAD", "");
                aux = aux.replace("NO STYLE", "");
                aux = aux.replaceAll(".0<", ".0&nbsp;<");
                console.log('table: ', aux);
                a.href = data_type + ', ' + encodeURIComponent(aux);
                //setting the file name
                a.download = 'Accounting Package Report' + postfix + ' .xls';
                //triggering the function
                a.click();
                // just in case, prevent default behaviour
                if(typeof e !== 'undefined')
                    e.preventDefault();

                return false;

                close_progress_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
                close_progress_loader();
            }

        });

    });
}
